import { useEffect } from 'react';
import { completeStartup } from '../utils/startup';

export default function usePageReady(ready = true) {
  useEffect(() => {
    if (ready) completeStartup();
  }, [ready]);
}
